import { render, staticRenderFns } from "./back12301.vue?vue&type=template&id=948a0a00&scoped=true"
import script from "./back12301.vue?vue&type=script&lang=js"
export * from "./back12301.vue?vue&type=script&lang=js"
import style0 from "./back12301.vue?vue&type=style&index=0&id=948a0a00&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "948a0a00",
  null
  
)

export default component.exports